module.exports = __webpack_public_path__ + "img/sets.60bde417.webp";